import { render, staticRenderFns } from "./SyaratKetentuan-Mobile.vue?vue&type=template&id=7303cf34&scoped=true"
import script from "./SyaratKetentuan-Mobile.vue?vue&type=script&lang=js"
export * from "./SyaratKetentuan-Mobile.vue?vue&type=script&lang=js"
import style0 from "./SyaratKetentuan-Mobile.vue?vue&type=style&index=0&id=7303cf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7303cf34",
  null
  
)

export default component.exports